import { render } from "./Payslip.vue?vue&type=template&id=8e4ce3a8"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__